<script>
import {
  iButton,
  iButtonSizes,
  iButtonStyles,
  iButtonTypes,
  iIcon,
} from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export const DATA_BRICK_ENTITY_TYPE = {
  DOCS: 'docs',
  HIGH_RISK_DOCS: 'high-risk-docs',
  FILE_TYPES: 'file-types',
  TRUST_SCORE: 'trust-score',
  CUSTOMER_RISK_LEVELS: 'customer-risk-levels',
};

export default {
  components: {
    iButton,
    iIcon,
  },
  props: {
    brickData: {
      type: Object,
      default: () => {},
    },
    size: {
      type: String,
      default: 'md',
    },
    colour: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    entity: {
      type: String,
      default: DATA_BRICK_ENTITY_TYPE.DOCS,
    },
  },
  data() {
    return {
      palette,
      iButtonSizes,
      iButtonStyles,
      iButtonTypes,
      DATA_BRICK_ENTITY_TYPE,
    };
  },
  computed: {
    displayPercentage() {
      if (this.brickData.percentage === '0%' && this.brickData.count > 0) {
        return '<1%';
      }
      return this.brickData.percentage;
    },
  },
  methods: {
    onClick() {
      this.$emit('brick-clicked');
    },
    onMouseOver() {
      this.$emit('onMouseOver');
    },
    onMouseOut() {
      this.$emit('onMouseOut');
    },
  },
};
</script>

<template>
  <div
    :class="{
      'i-px-8': size === 'lg',
      'i-py-6': size === 'lg',
      'i-px-6': size === 'md',
      'i-py-4': size === 'md',
      clickable,
      lg: size === 'lg',
      md: size === 'md',
      'i-gap-6': entity === DATA_BRICK_ENTITY_TYPE.CUSTOMER_RISK_LEVELS,
      'align-items-center':
        entity === DATA_BRICK_ENTITY_TYPE.CUSTOMER_RISK_LEVELS,
    }"
    class="data-brick d-flex flex-row i-radius-lg"
    @click="clickable && onClick()"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut"
  >
    <div
      v-if="entity !== DATA_BRICK_ENTITY_TYPE.CUSTOMER_RISK_LEVELS"
      :style="{ background: brickData.color }"
      :class="{ 'i-mr-6': size === 'lg', 'i-mr-4': size === 'md' }"
      class="tag"
    ></div>
    <div
      v-else
      class="icon-container d-flex flex-row align-items-center justify-content-center"
      :style="{ background: palette[brickData.iconBackgroundColor] }"
    >
      <i-icon
        class="left-icon"
        :symbol="brickData.icon"
        :colour="palette[brickData.color]"
        :size="12"
      ></i-icon>
    </div>
    <div class="text d-flex flex-column justify-content-center">
      <div class="first-line d-flex flex-row">
        <div class="title i-text-neutral-120 i-text-subheading-3">
          {{ brickData.title }}
        </div>
        <div
          v-if="size === 'md'"
          class="percentage i-text-neutral-110 i-text-body-3 i-ml-4"
        >
          {{ displayPercentage }}
        </div>
      </div>
      <div
        v-if="size === 'lg'"
        class="subtitle i-text-neutral-110 i-text-body-3 i-mt-1"
      >
        {{ displayPercentage }} • {{ brickData.count }}
        <span v-if="entity === DATA_BRICK_ENTITY_TYPE.CUSTOMER_RISK_LEVELS">
          {{ brickData.count === 1 ? 'customer' : 'customers' }}
        </span>
        <span v-else>
          {{ brickData.count === 1 ? 'document' : 'documents' }}
        </span>
      </div>
    </div>
    <div class="icon-wrapper d-flex flex-column justify-content-center">
      <i-button
        class="link-icon"
        :left-icon="'medium-arrows-right'"
        :size="iButtonSizes.SM"
        :type="iButtonTypes.NEUTRAL"
        :button-style="iButtonStyles.OUTLINE"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.data-brick {
  border: 1px solid $light-neutral-60;
  justify-content: space-between;

  .link-icon {
    visibility: hidden;
  }
  &.clickable {
    cursor: pointer;

    .link-icon {
      display: flex;
      visibility: hidden;
    }

    &:hover {
      border: 1px solid $light-neutral-80;

      .link-icon {
        visibility: visible;
      }
    }
  }

  .text {
    flex: 1;
  }

  .tag {
    border-radius: 10px;
    width: 3px;
  }

  .icon-wrapper {
    height: 100%;
  }
  .icon-container {
    width: 32px;
    height: 32px;
    border-radius: 100px;
  }
}
</style>
